module.exports = __webpack_public_path__ + "img/629dc7015cee93de7d5fb6e551394744.png";